import { useEffect, useState } from "react";
import api from "../../../../apis";

const useDetailData = (id?: any, open?: boolean) => {
  const [data, setData] = useState<any>();
  useEffect(() => {
    // 示例请求
    if (open) {
      api
        .post(`/yunditu/admin/index.php?d=api&c=yewu&m=getDituDetails`, { id })
        .then((res: any) => {
          console.log("响应数据:", res);
          setData(res);
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    }
  }, [id, open]);

  return data;
};

export default useDetailData;
